export const HomeTypes = {
  IHomeService: Symbol("IHomeService"),
};
